import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useAuth } from '../components/auth/use-auth';

/** Ziel aller Seiten-Guards, wenn eine Permission fehlt — ohne Redirect-Schleife. */
const KeinZugriff = () => {
  const { isAuthenticated, logout } = useAuth();
  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="max-w-md space-y-4 text-center">
        <ShieldOff className="mx-auto h-10 w-10 text-muted-foreground" aria-hidden="true" />
        <h1 className="text-xl font-semibold">Kein Zugriff</h1>
        <p className="text-sm text-muted-foreground">
          Für diesen Bereich fehlt Ihnen die Berechtigung. Wenn Sie ihn für Ihre Arbeit brauchen,
          wenden Sie sich an Ihre Standortleitung oder die Administration.
        </p>
        <div className="flex justify-center gap-2">
          {isAuthenticated ? (
            <>
              <Button asChild>
                <Link to="/dashboard">Zur Übersicht</Link>
              </Button>
              <Button variant="ghost" onClick={() => void logout()}>
                Abmelden
              </Button>
            </>
          ) : (
            <Button asChild>
              <Link to="/login">Zur Anmeldung</Link>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default KeinZugriff;
